import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from '../Input';

export const renderInput = ({ input, meta: { touched, invalid, error }, ...props }) => (
  <Input error={touched && invalid} helperText={touched && error} {...input} onChange={input.onChange} {...props} />
);

renderInput.propTypes = {
  input: PropTypes.shape({}),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }),
};

renderInput.defaultProps = {
  input: {},
  meta: {},
};

const FormInput = ({ name, ...props }) => <Field name={name} component={renderInput} {...props} />;

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormInput;
